export default __webpack_public_path__ + "static/media/aviao.f158e058.jpg";